import { useCallback, useSyncExternalStore } from 'react'

export type Density = 'compact' | 'comfortable'
const KEY = 'bloo.density'
const listeners = new Set<() => void>()

function read(): Density {
  const raw = typeof window !== 'undefined' ? window.localStorage.getItem(KEY) : null
  return raw === 'comfortable' ? 'comfortable' : 'compact' // dense by default, per brief
}

let current: Density = read()

function apply(d: Density) {
  document.documentElement.setAttribute('data-density', d)
}
if (typeof document !== 'undefined') apply(current)

export function useDensity(): [Density, (d: Density) => void] {
  const density = useSyncExternalStore(
    (cb) => {
      listeners.add(cb)
      return () => listeners.delete(cb)
    },
    () => current,
  )
  const set = useCallback((d: Density) => {
    current = d
    window.localStorage.setItem(KEY, d)
    apply(d)
    listeners.forEach((cb) => cb())
  }, [])
  return [density, set]
}
